<section class="purchase-history">
  <div class="purchase-history-title">
    <mat-icon
      class="purchase-history-title-icon"
      aria-hidden="true"
      >history</mat-icon
    >
    <span>{{ title }}</span>
  </div>

  @if (hasHistory) {
    <div class="purchase-history-content">
      @for (row of summaryRows; track row.label) {
        <div class="purchase-history-row">
          <mat-icon
            class="purchase-history-icon"
            aria-hidden="true"
            >{{ row.icon }}</mat-icon
          >
          <span class="purchase-history-label">{{ row.label }}</span>
          <span
            class="purchase-history-value"
            [class.purchase-history-value--success]="row.valueClass === 'success'">
            {{ row.value }}
          </span>
        </div>
      }
      @if (ipcaRow(); as row) {
        <div class="purchase-history-row purchase-history-row--comparison">
          <mat-icon
            class="purchase-history-icon"
            aria-hidden="true"
            >trending_up</mat-icon
          >
          <span class="purchase-history-label">{{ row.label }}</span>
          <span class="purchase-history-value purchase-history-value--stack">
            <span>{{ row.value }}</span>
            <span class="purchase-history-delta">{{ row.hint }}</span>
            @if (row.comparison; as comparison) {
              <span
                class="purchase-history-delta"
                [class.purchase-history-delta--warning]="comparison.valueClass === 'warning'"
                [class.purchase-history-delta--success]="comparison.valueClass === 'success'"
                >{{ comparison.text }}</span
              >
            }
          </span>
        </div>
      }
      @if (comparisonRow; as row) {
        <div class="purchase-history-row purchase-history-row--comparison">
          <mat-icon
            class="purchase-history-icon"
            aria-hidden="true"
            >{{ row.icon }}</mat-icon
          >
          <span class="purchase-history-label">{{ row.label }}</span>
          <span class="purchase-history-value purchase-history-value--stack">
            <span>{{ row.value }}</span>
            <span
              class="purchase-history-delta"
              [class.purchase-history-delta--warning]="row.valueClass === 'warning'"
              [class.purchase-history-delta--success]="row.valueClass === 'success'"
              >{{ row.hint }}</span
            >
          </span>
        </div>
      }
    </div>

    <mat-divider class="purchase-history-divider" />

    <div class="purchase-history-content">
      @for (row of contextRows; track row.label) {
        <div class="purchase-history-row">
          <mat-icon
            class="purchase-history-icon"
            aria-hidden="true"
            >{{ row.icon }}</mat-icon
          >
          <span class="purchase-history-label">{{ row.label }}</span>
          <span
            class="purchase-history-value purchase-history-value--context text-truncate"
            [title]="row.fullValue ?? row.value">
            {{ row.value }}
            @if (row.hint) {
              <span class="purchase-history-hint">· {{ row.hint }}</span>
            }
          </span>
        </div>
      }
    </div>
  } @else {
    <div class="purchase-history-empty">Ainda não há histórico de negociação para esse item</div>
  }

  @if (podeVerCompleto) {
    <button
      type="button"
      class="purchase-history-more"
      (click)="verHistoricoCompleto()">
      Ver histórico completo
      <mat-icon aria-hidden="true">open_in_new</mat-icon>
    </button>
  }
</section>
